import TextCell from 'components/TextCell';
import type { ManagedOemSegmentType } from '../..';

interface CellProps {
  rowData: ManagedOemSegmentType;
}

export default function CreatedByCell({ rowData: { createdBy } }: CellProps) {
  return <TextCell text={createdBy?.username || createdBy?.email} />;
}
